import { CompanyNameField, FieldNode, NameField } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

const SYNC_FIELDS = ['NAME', 'COMPANY_NAME', 'ADDRESS'];

export function isAutofillableField(
  node: DeepReadonly<FieldNode>
): node is NameField | CompanyNameField {
  return SYNC_FIELDS.includes(node.type);
}
